// Constantes para fechas límite del calendar
export const MIN_DATE = new Date(1900, 0, 1);
export const MAX_DATE = new Date(2099, 11, 31);

/**
 * Obtiene una fecha mínima segura para form controls
 */
export function getSafeMinDate(min?: Date): Date {
  return min || MIN_DATE;
}

/**
 * Obtiene una fecha máxima segura para form controls
 */
export function getSafeMaxDate(max?: Date): Date {
  return max || MAX_DATE;
}

/**
 * Obtiene el año mínimo permitido para el calendar
 */
export function getMinYear(min?: Date): number {
  return (min || MIN_DATE).getFullYear();
}

/**
 * Obtiene el año máximo permitido para el calendar
 */
export function getMaxYear(max?: Date): number {
  return (max || MAX_DATE).getFullYear();
}

/**
 * Verifica si hay incongruencia entre fechas mínima y máxima en el calendar
 */
export function hasDateIncongruence(min?: Date, max?: Date): boolean {
  const safeMin = min || MIN_DATE;
  const safeMax = max || MAX_DATE;
  return safeMax < safeMin;
}

/**
 * Verifica si una fecha está dentro de un rango específico
 */
export function isWithinRange(date: Date, min?: Date, max?: Date): boolean {
  const safeMin = min || MIN_DATE;
  const safeMax = max || MAX_DATE;
  return date >= safeMin && date <= safeMax;
}
